import { render } from "./StepC.vue?vue&type=template&id=2c1be1ad"
import script from "./StepC.vue?vue&type=script&lang=js"
export * from "./StepC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__